module.exports = __webpack_public_path__ + "assets/img/slogan-131eecaf.png";